import PropTypes from "prop-types";
import StyledFaqLink from "./StyledFaqLink";
import StyledFaqLinkHeading from "./StyledFaqLinkHeading";

export default function FaqLink({ section, suffix = "", size }) {
	return (
		<StyledFaqLink to={`/help/${section.slug}`}>
			<StyledFaqLinkHeading size={size} content={`${section.title}${suffix}`} />
		</StyledFaqLink>
	);
}

FaqLink.propTypes = {
	section: PropTypes.object.isRequired,
	size: PropTypes.oneOf(["h1", "h2", "h3", "h4"]),
	suffix: PropTypes.string, // sometimes we need to add "FAQs" at the end of the title
};
